import { PieceProvider } from "../PieceProvider.js";
import type { PlayerType } from "../../model/PlayerType.js";
import { Piece } from "../../model/Piece.js";


/**
 * Provides new instances of, and manipulations to, simple pieces.
 */
export class SimplePieceProvider extends PieceProvider {
    create(owner: PlayerType, pathIndex: number): Piece {
        return new Piece(owner, pathIndex);
    }

    createIntroduced(owner: PlayerType, newPathIndex: number): Piece {
        return new Piece(owner, newPathIndex);
    }

    createMoved(fromPiece: Piece, newPathIndex: number): Piece {
        return new Piece(fromPiece.getOwner(), newPathIndex);
    }
}
